exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-icon[data-v-1b0fc798]{width:1.5em;height:1.5em;vertical-align:-0.15em;fill:currentColor;overflow:hidden}\n", ""]);

// exports
